import themes from '@bnnvara/themes';
import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';
export const Check = ({
  color
}) => /*#__PURE__*/React.createElement(S.Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "check",
  viewBox: "0 0 64 64",
  color: color
}, /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M25.07,41.81 L13.83,30.56 L11,33.39 L23.49,45.88 L24.17,46.57 C24.3798229,46.8471619 24.7073732,47.0100187 25.055,47.0100187 C25.4026268,47.0100187 25.7301771,46.8471619 25.94,46.57 L26.66,45.85 L53,19.8 L50.17,17 L25.07,41.81 Z"
})));
Check.propTypes = {
  color: PropTypes.string
};
Check.defaultProps = {
  color: themes.bnnvara.base.white
};